import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import AC from "agora-chat";
import { getBaseUrl } from "../utils";
import "../styles.css"; // Import the custom CSS

const baseUrl = getBaseUrl();
const APP_ID = "611323081#1524731";

const AgoraChat = () => {
    const { userId, adminId } = useParams();
    const [messages, setMessages] = useState([]);
    const [messageInput, setMessageInput] = useState("");
    const [token, setToken] = useState(null);
    const [adminInfo, setAdminData] = useState({});

    const chatClient = useRef(null);


    useEffect(() => {
        const get_admin_info = async () => {
            try {
                const response = await fetch(`${baseUrl}user_api/get_admin_info?adminId=${adminId}`);
                const data = await response.json();
                console.log("data--->",data);
                console.log("data-1----------------->",data.results);

                if (data.status) {
                console.log("data-0----------------->",data.results);

                    setAdminData(data.results);
                } else {
                    console.error("Failed to get_admin_info");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
            }
        };

        get_admin_info();
    }, [adminId]);

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await fetch(`${baseUrl}user_api/agora_chat_token?userId=${userId}`);
                const data = await response.json();
                if (data.token) {
                    setToken(data.token);
                } else {
                    console.error("Failed to fetch token");
                }
            } catch (error) {
                console.error("Error fetching token:", error);
            }
        };

        fetchToken();
    }, [userId]);

    useEffect(() => {
        const initChat = async () => {
            if (!APP_ID || !token) return;

            try {
                if (chatClient.current && chatClient.current.isOpened()) {
                    console.log("Closing existing connection...");
                    await chatClient.current.close();
                }

                chatClient.current = new AC.connection({ appKey: APP_ID, multiDevice: true });
                chatClient.current.addEventHandler("connection&message", {
                    onConnected: () => console.log(`User ${userId} connected successfully!`),
                    onDisconnected: () => console.log("User disconnected"),
                    onTextMessage: (message) => {
                        setMessages(prevMessages => [...prevMessages, {
                            sender: message.from,
                            text: message.msg,
                            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                        }]);
                    },
                });

                await chatClient.current.open({ user: userId, accessToken: token });
            } catch (error) {
                console.error("Error initializing Agora Chat:", error);
            }
        };

        if (token) {
            initChat();
        }

        return () => chatClient.current && chatClient.current.close();
    }, [userId, token]);

    const sendMessage = async () => {
        if (!messageInput.trim()) return;
        try {
            const msg = AC.message.create({
                chatType: "singleChat",
                type: "txt",
                to: adminId,
                msg: messageInput,
            });
            await chatClient.current.send(msg);
            setMessages(prevMessages => [...prevMessages, {
                sender: "Me",
                text: messageInput,
                time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
            }]);
            setMessageInput("");
        } catch (error) {
            console.error("Error sending message:", error);
        }
    };

    return (
        <div className="chat-container">
            <header className="chat-header">
                <img src={adminInfo.profile_img} alt="User Avatar" className="avatar" />
                <div>
                    <h3>{adminInfo.name}</h3>
                    <span className="status">● Online</span>
                </div>
                {/* <span className="call-duration">30:00</span> */}
            </header>

            <div className="chat-box">
                {messages.map((msg, index) => (
                    <div key={index} className={`message ${msg.sender === "Me" ? "me" : "other"}`}>
                        <p>{msg.text}</p>
                        <span className="timestamp">{msg.time}</span>
                    </div>
                ))}
            </div>

            <div className="input-area">
                <input
                    type="text"
                    value={messageInput}
                    onChange={(e) => setMessageInput(e.target.value)}
                    placeholder="Type Message here..."
                />
                <button onClick={sendMessage}>➤</button>
            </div>
        </div>
    );
};

export default AgoraChat;
